exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-journeysponsor-js": () => import("./../../../src/pages/journeysponsor.js" /* webpackChunkName: "component---src-pages-journeysponsor-js" */),
  "component---src-pages-keynote-speaking-js": () => import("./../../../src/pages/keynote-speaking.js" /* webpackChunkName: "component---src-pages-keynote-speaking-js" */)
}

